import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const groupServices = {
  addNewGroup,
  updatedGroup,
  deleteGroup,
  softDeleteRestoreGroup,
  getGroupList,
  getSingleGroup,
};

// Add New Group
async function addNewGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewGroup`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Group
async function updatedGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedGroup`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Group
async function deleteGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteGroup`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Group
async function softDeleteRestoreGroup(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreGroup`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Group
async function getGroupList(auth, status, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest(`getGroupList/${status}`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getGroupList/${status}?search=${searchData || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getGroupList/${status}?search=${searchData || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Group Details
async function getSingleGroup(auth, groupId) {
  try {
    const signal = cancelPreviousRequest("getSingleGroup");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleGroup/${groupId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}